import axios from 'axios'

import { SERASA_API_BASE_URL } from '@/config/api'
import { DEFAULT_REQUEST_CONFIG } from '@/config/request'

export const serasaApiRequest = axios.create({
  baseURL: SERASA_API_BASE_URL,
  headers: {
    ...DEFAULT_REQUEST_CONFIG.headers,
    'Captcha-Format-Accept':
      'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,*/*;q=0.8',
  },
})
